import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import { useCouponDetails } from '../../hooks/useCouponDetails'
import type { CouponItem } from '../../types/coupons.types'

export type CouponProps = {
	coupon: CouponItem
	menuOptions: Option[]
}

export const Coupon = ({ coupon, menuOptions }: CouponProps) => {
	const { t } = useTranslation()
	const getDetails = useCouponDetails()
	const details = getDetails(coupon)

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{coupon.code}</p>
				<ContextMenu
					dataId={coupon.id}
					item={coupon}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: coupon.code })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Status')} value={details.status} />
				<Detail label={t('Price discount')} value={details.discount} />
				<Detail label={t('Booking window')} value={details.bookingWindow} />
				<Detail label={t('# Used')} value={coupon.times_used} />
				<Detail label={t('Max uses')} value={details.maxUses} />
				<Detail label={t('Expires')} value={details.expires} />
			</dl>
		</li>
	)
}
